import React, { useMemo, useState } from "react";
import "./Style.css";
import {
  FaBars,
  FaTimes,
  FaUser,
  FaHospital,
  FaUserMd,
  FaProcedures,
  FaKey,
  FaSignOutAlt,
} from "react-icons/fa";
import logo from "../../Assets/Images/medconnect-logo.png";
import { Modal } from "antd";
import Profile from "./Components/Profile/Profile";
import HospitalManagement from "./Components/HospitalManagement/HospitalManagement";
import DoctorManagement from "./Components/DoctorManagement/DoctorManagement";
import AccessManagement from "./Components/AccessManagement/AccessManagement";
import PatientManagement from "./Components/PatientManagementComponent/PatientManagement";

const Dashboard = () => {
  const [activePage, setActivePage] = useState(
    localStorage.getItem("activePage") || "profile"
  );
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const [isLogoutModalVisible, setLogoutModalVisible] = useState(false);

  const filteredRoles = useMemo(() => {
    const storedRoles = sessionStorage.getItem("filteredRoles");
    const roles = storedRoles ? JSON.parse(storedRoles) : [];
    const storedUserDetails = sessionStorage.getItem("userDetails");
    const userDetails = storedUserDetails ? JSON.parse(storedUserDetails) : null;

    const patientPermission = roles
      .filter((role) => role.roleName === "Patient")
      .some((role) =>
        userDetails?.role?.permissions?.some(
          (entry) =>
            entry.resource === role.roleName && entry.actions.includes("View")
        )
      );

    const staffPermission = roles
      .filter((role) => role.roleName !== "Patient")
      .some((role) =>
        userDetails?.role?.permissions?.some(
          (entry) =>
            entry.resource === role.roleName && entry.actions.includes("View")
        )
      );

    return { staffPermission, patientPermission };
  }, []);

  const role =
    JSON.parse(sessionStorage.getItem("userDetails"))?.role.roleName ||
    JSON.parse(sessionStorage.getItem("userDetails"))?.role;

  const menuItems = [
    { name: "Profile", icon: <FaUser />, key: "profile" },
    ...(role === "SuperAdmin"
      ? [{ name: "Hospital Management", icon: <FaHospital />, key: "hospital-management" }]
      : []),
    ...(role === "Admin"
      ? [{ name: "Access Management", icon: <FaKey />, key: "access-management" }]
      : []),
    ...(filteredRoles.patientPermission
      ? [{ name: "Patient Management", icon: <FaProcedures />, key: "patient-management" }]
      : []),
    ...(filteredRoles.staffPermission
      ? [{ name: "Staff Management", icon: <FaUserMd />, key: "staff-management" }]
      : []),
    { name: "Logout", icon: <FaSignOutAlt />, key: "logout" },
  ];

  const handleNavClick = (key) => {
    if (key === "logout") {
      setLogoutModalVisible(true);
    } else {
      setActivePage(key);
      setIsMobileSidebarOpen(false);
    }
  };

  const handleLogoutConfirm = () => {
    sessionStorage.clear();
    setLogoutModalVisible(false);
    window.location.href = "/";
  };

  const renderActiveComponent = () => {
    switch (activePage) {
      case "profile":
        return <Profile />;
      case "hospital-management":
        return <HospitalManagement />;
      case "staff-management":
        return <DoctorManagement />;
      case "patient-management":
        return <PatientManagement />;
      case "access-management":
        return <AccessManagement />;
      default:
        return <div>Select a section to begin.</div>;
    }
  };

  return (
    <div className="dashboard-container">
      <aside className={`desktop-sidebar ${isSidebarOpen ? "open" : "collapsed"}`}>
        <div className="sidebar-header">
          {isSidebarOpen && (
            <div className="logo">
              <img src={logo} alt="logo" />
              <h2>Increvelsoft</h2>
            </div>
          )}
          <FaBars onClick={() => setIsSidebarOpen(!isSidebarOpen)} />
        </div>
        <hr />
        <nav className="menu">
          {menuItems.map(
            (item) =>
              item && (
                <div
                  key={item.key}
                  className={`menu-item ${activePage === item.key ? "active" : ""}`}
                  onClick={() => handleNavClick(item.key)}
                >
                  <span className="icon">{item.icon}</span>
                  {isSidebarOpen && <span>{item.name}</span>}
                </div>
              )
          )}
        </nav>
      </aside>

      <main className="main-content">
        <h1>{menuItems.find((item) => item?.key === activePage)?.name}</h1>
        {renderActiveComponent()}
      </main>

      <footer>2024 &copy; Increvelsoft Private Limited</footer>

      <Modal
        title="Confirm Logout"
        open={isLogoutModalVisible}
        onOk={handleLogoutConfirm}
        onCancel={() => setLogoutModalVisible(false)}
      >
        <p>Are you sure you want to logout?</p>
      </Modal>
    </div>
  );
};

export default Dashboard;
